import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import logo from "@/assets/logo.png";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-slate-800 bg-slate-900" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <img src={logo} alt="SlimeGlass" className="h-12 w-auto mb-6 brightness-0 invert" />
            <p className="font-body text-slate-400 max-w-sm leading-relaxed">
              {t("footer.desc")}
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono-x text-[10px] uppercase tracking-widest text-[hsl(var(--accent))] mb-4">{t("footer.shop")}</p>
            <ul className="space-y-3 font-body text-slate-300">
              <li><Link to="/shop" className="hover:text-[hsl(var(--accent))] transition-colors">{t("footer.allTips")}</Link></li>
              <li><Link to="/shop" className="hover:text-[hsl(var(--accent))] transition-colors">12mm Blue Tip</Link></li>
              <li><Link to="/shop" className="hover:text-[hsl(var(--accent))] transition-colors">12mm Orange Tip</Link></li>
              <li><Link to="/shop" className="hover:text-[hsl(var(--accent))] transition-colors">J Bands</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono-x text-[10px] uppercase tracking-widest text-[hsl(var(--accent))] mb-4">{t("footer.follow")}</p>
            <a href="https://www.instagram.com/slimeeglass" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="inline-flex items-center gap-2 font-body text-slate-300 hover:text-[hsl(var(--accent))] transition-colors">
              <Instagram className="h-4 w-4" /> @slimeeglass
            </a>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-mono-x text-[10px] uppercase tracking-widest text-slate-500">© {new Date().getFullYear()} SlimeGlass. {t("footer.rights")}</p>
          <p className="font-mono-x text-[10px] uppercase tracking-widest text-slate-500">{t("footer.age")}</p>
        </div>
      </div>
    </footer>
  );
}
